import webClient from "../config/api.config";

/**
 * MED-1447: the four in-app notification operations `medecine360-bff`
 * exposes. Every one of them is scoped to the caller's own session — none
 * takes a user id.
 */
export function getNotifications() {
  return webClient.request({
    method: "get",
    url: "notifications",
  });
}

export function markNotificationAsRead(id: number) {
  return webClient.request({
    method: "put",
    url: `notifications/${id}/read`,
  });
}

export function markAllNotificationsAsRead() {
  return webClient.request({
    method: "put",
    url: "notifications/read-all",
  });
}

export function deleteNotification(id: number) {
  return webClient.request({
    method: "delete",
    url: `notifications/${id}`,
  });
}
